export default class Contact {
   constructor(bxItem) {
      this.id = bxItem.ID;
      this.name = bxItem.TITLE; // «ФИО гражданина» из лида?
      this.birthDate = new Date(bxItem.BIRTHDATE);
      this.phone = Array.isArray(bxItem.PHONE)
         ? bxItem.PHONE.map(item => item.VALUE).join(', ')
         : '';
      this.email = Array.isArray(bxItem.EMAIL)
         ? bxItem.EMAIL.map(item => item.VALUE).join(', ')
         : '';
      this.typeId = bxItem.UF_CRM_1441811437;
      this.ogrn = bxItem.UF_CRM_1515572168;
      this.regDate = new Date(bxItem.UF_CRM_1515578742);
      this.subject = bxItem.TITLE;
      this.inn = bxItem.UF_CRM_1642513981;
      this.leadActivity = bxItem.UF_CRM_1528276326;
   }

   get type() {
      switch(this.typeId) {
         case '98': return 'contactType.scholar';
         case '100': return 'contactType.student';
         case '102': return 'contactType.unemployed';
         case '104': return 'contactType.retiree';
         case '106': return 'contactType.employee';
         case '108': return 'contactType.ooo';
         case '94': return 'contactType.ip';
         case '110': return 'contactType.ipndp';
         case '253': return 'contactType.selfEmployed';
         case '255': return 'contactType.other';
         default: return ''
      }
   }
}